import { PreviewModel, Position } from './preview.model';
import { Injectable } from '@angular/core';
import { OrganizationModel } from '../../modules/organization/model/organization.model';
import { ModuleModel } from '../../modules/module.model.interface';
import { RendererFactory } from './renderer';
import { ProfileModel } from '../../modules/profile/model/profile.model';
import * as $ from 'jquery';
import { FormDescriptor } from '../../modules/form/model/form';
import { DataEntryHistoryDescriptor } from '../../modules/dataentry.history/model/dataentry.history';
import { FormManifestCheckDescriptor } from '../../modules/form.manifest/model/form.manifest.check';

@Injectable()
export class PreviewService {

  public previewModel: PreviewModel = new PreviewModel();

  showPreview(preview: ModuleModel, event: any): void {

    const position = new Position(event.pageX - event.offsetX - 6, event.pageY - event.offsetY - 6);

    this.previewModel.Data = preview;

    if (preview.discriminator === new ProfileModel().discriminator) {
      this.previewModel.R = RendererFactory.Profile.Renderer;
      this.previewModel.position = position;
    }

    if (preview.discriminator === new OrganizationModel().discriminator) {
      this.previewModel.R = RendererFactory.Organization.Renderer;
      this.previewModel.position = position;
    }

    if (preview.discriminator === new FormDescriptor().discriminator) {
      this.previewModel.R = RendererFactory.Form.Renderer;
      this.previewModel.position = position;
    }

    if (preview.discriminator === new DataEntryHistoryDescriptor().discriminator) {
      this.previewModel.R = RendererFactory.DataEntryHistory.Renderer;
      this.previewModel.position = new Position(event.pageX - event.offsetX - 185, event.pageY - event.offsetY + 33);
    }

    if (preview.discriminator === new FormManifestCheckDescriptor().discriminator) {
      this.previewModel.R = RendererFactory.FormCheck.Renderer;
      this.previewModel.position = new Position(NaN, 430);
    }

    if (typeof preview === 'string') {
      this.previewModel.R = RendererFactory.String.Renderer;
      this.previewModel.position = position;
    }

    this.showModal();
  }

  showModal() {
    $('#previewModal').modal('show');
  }

  hideModal() {
    this.previewModel.clear();

    $('#previewModal').modal('hide');
  }
}



// WEBPACK FOOTER //
// ./src/app/common/preview.service/preview.service.ts